module.exports = __webpack_public_path__ + "static/media/React-icon.05a3e30f.svg";